import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { TourSequence } from '@/domain/project-tour-ontour/entities/project-tour-ontour-sequence.entity';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { translate } from '@/ui/i18n';

export type TourSequenceFormInput = {
  name: string;
};

export function TourSequenceForm({
  sequence,
  onClose,
  onSubmit,
}: {
  sequence: TourSequence;
  onClose: () => void;
  onSubmit: (data: TourSequenceFormInput) => void;
}) {
  const { register, handleSubmit, setFocus } = useForm<TourSequenceFormInput>({
    defaultValues: {
      name: sequence.name,
    },
  });

  useEffect(() => {
    setFocus('name');
  }, [setFocus]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack>
        <FSTextField
          label={translate('ProjectsTour.SequenceForm.sequence-name')}
          register={{
            ...register('name'),
            required: true,
          }}
        />
        <Stack
          sx={{ flexDirection: 'row', justifyContent: 'end', mt: 1, gap: 1 }}
        >
          <FSSecondaryButton onClick={onClose}>
            {translate('Form.cancel')}
          </FSSecondaryButton>
          <FSPrimaryButton type="submit">
            {translate('Form.save')}
          </FSPrimaryButton>
        </Stack>
      </Stack>
    </form>
  );
}
